import "./ContactUs.css";

import ContactUsForm from "./form/Form";

const contacts = [
  {
    category: "Railcar Storage",
    name: "David McCloud",
    phone: "(904) 303-5966",
    email: "storage@watco.com"
  },
  {
    category: "Transloading, Material Handling & Storage",
    name: "Jana Austerman",
    phone: "(620) 240-6626",
    email: "sales@watco.com"
  },
  {
    category: "Find Property",
    name: "Luke Bellamy",
    phone: "(208) 431-2556",
    email: "industrialdevelopment@watco.com"
  }
];

export default function ContactUs() {
  return (
    <div className="contact-us">
      <div className="form-container">
        <h1>Whatever you need, we're here to help.</h1>
        <h2>Contact Us</h2>
        {contacts.map((contact, index) =>
          <div key={index} className="contact-section">
            <h3>{contact.category}</h3>
            {contact.name &&
              <div>{contact.name}</div>
            }
            {contact.phone &&
              <div><a href={`tel:${contact.phone}`}>{contact.phone}</a></div>
            }
            <div><a href={`mailto:${contact.email}`}>{contact.email}</a></div>
          </div>
        )}
        <div className="contact-us-form-wrapper">
          <h2>We'll Contact You</h2>
          <ContactUsForm />
        </div>
      </div>
    </div>
  )
}